import { createData } from "../../Services/DataServices";

export const loginService = async (formData) => {
  return await createData("user/login", formData);
};
